import {
  Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';
import { ConfigurationService } from '@sondermind/configuration';
import {
  EmptyURIValue,
  encodeSpecialCharacters,
  URIPrefix,
} from '@sondermind/data-access/directory-link';
import {
  BrowseLinkKeys, BrowseLinkKeyType, IAPIListRequestOptions, IAPIListResponse, IBrowseLinkApiResponse, IBrowseLinkData
} from '@sondermind/utilities/models-http';

import { BrowseStateHttpService } from '@sondermind/utilities/services';

@Component({
  selector: 'browse-therapists-card',
  templateUrl: './browse-therapists-card.component.html',
  styleUrls: ['./browse-therapists-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
  ],
})
export class BrowseTherapistsCard implements OnInit, OnChanges {
  @Input() currentStateAbbrev!: string;

  destroyed$ = new Subject<void>();
  cities!: IBrowseLinkData[];
  insurances!: IBrowseLinkData[];
  specialities!: IBrowseLinkData[];
  emptyURIValue = EmptyURIValue;
  uriPrefix = URIPrefix;
  providerDirectoryUrl: string = '';

  constructor(
    private browseStateHttpService: BrowseStateHttpService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit(): void {
    this.providerDirectoryUrl =
    this.configurationService.env.providerDirectoryBase ||
    'https://www.sondermind.com/provider-directory';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentStateAbbrev']?.currentValue) {
      this.currentStateAbbrev = changes['currentStateAbbrev']?.currentValue;
      this.getBrowseLinks();
    }
  }

  getBrowseLinks(): void {
    const options: IAPIListRequestOptions = {
      page: 'disabled',
      filter: { key: 'state', value: this.currentStateAbbrev },
    };

    this.browseStateHttpService
      .getBrowseLinks(options)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(({ data }: IAPIListResponse<IBrowseLinkApiResponse>) => {
        this.cities = this.getTopItems(data, BrowseLinkKeys.CITY, 5);
        this.insurances = this.getTopItems(data, BrowseLinkKeys.INSURANCE, 5);
        this.specialities = this.getTopItems(data, BrowseLinkKeys.SPECIALTY, 5);
      });
  }

  // Filter then sort by provider_count in descending order
  // And slice given count
  private getTopItems(
    items: IBrowseLinkApiResponse[],
    key: BrowseLinkKeyType,
    count: number,
  ): IBrowseLinkData[] {
    return items
      .filter((item) => item[key] != null)
      .sort((a, b) => b.provider_count - a.provider_count)
      .slice(0, count)
      .map((item) => {
        const value = item[key] as string;
        return {
          value,
          uriSafeValue: encodeURIComponent(encodeSpecialCharacters(value.toLocaleLowerCase())),
        };
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
